/* global window, Proxy */
import bootstrap from "./bootstrap";
import helpers from "./legacy/helpers";
import amplitude from "./amplitude";
import initReact from "./initReact";
import initAlpine from "./initAlpine";
import confetti from "canvas-confetti";

if (typeof window.Castos === "undefined") {
  window.Castos = {};
}

window.Confetti = confetti;
window.Castos.helpers = helpers;

bootstrap();

if (amplitude !== null) {
  window.Amplitude = amplitude;
} else {
  // Create a proxy to throw away calls to Amplitude if not configured.
  let fakeAmplitude = {};
  window.Amplitude = new Proxy(fakeAmplitude, {
    get() {
      return () => {};
    },
    set() {
      return () => {};
    },
    apply() {
      return;
    },
  });
}

window.applyTags = function (logEvent, eventProperties = {}) {
  const customField = logEvent + "_date";

  const userProperties = {
    user_id: window.Castos.config.userEmail,
    user_name: window.Castos.config.userName,
  };
  window.Amplitude.setUserProperties(userProperties);
  window.Amplitude.logEvent(logEvent, eventProperties);

  if (typeof window._dcq !== "undefined") {
    window._dcq.push([
      "identify",
      {
        email: window.Castos.config.userEmail,
        user_name: window.Castos.config.userName,
        tags: [logEvent],
        [customField]: new Date().toISOString().slice(0, 10),
      },
    ]);
  }
};

initAlpine();
initReact();
